import { PriceContext, UserContext } from "libs/contexts"
import { useContext } from "react"

export default function useRateAndSellCount() {
  const userInfo = useContext(UserContext)
  const priceData = useContext(PriceContext)
  const { showPrice } = priceData

  return {
    showPrice,
    canView: userInfo || showPrice,
  }
}
